import React from 'react';
import { Table, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { PresetListItem } from '../../../../services/configPresetAPI';
import { ComparisonRow } from './usePresetComparison';

interface ComparisonTableProps {
    tableData: ComparisonRow[];
    selectedPresets: string[];
    presets: PresetListItem[];
}

export const ComparisonTable: React.FC<ComparisonTableProps> = ({
    tableData,
    selectedPresets,
    presets,
}) => {
    const buildColumns = (): ColumnsType<ComparisonRow> => {
        const baseColumns: ColumnsType<ComparisonRow> = [
            {
                title: '结果指标',
                dataIndex: 'metric',
                key: 'metric',
                width: 150,
                fixed: 'left',
                onCell: (record, index) => {
                    const prevRow = tableData[index! - 1];
                    if (prevRow && prevRow.metric === record.metric) {
                        return { rowSpan: 0 };
                    }
                    let rowSpan = 1;
                    for (let i = index! + 1; i < tableData.length; i++) {
                        if (tableData[i].metric === record.metric) {
                            rowSpan++;
                        } else {
                            break;
                        }
                    }
                    return { rowSpan };
                },
            },
            {
                title: '子维度',
                dataIndex: 'component',
                key: 'component',
                width: 150,
                fixed: 'left',
            },
        ];

        const presetColumns: ColumnsType<ComparisonRow> = selectedPresets.map((presetKey) => {
            const presetInfo = presets.find((p) => p.key === presetKey);
            return {
                title: presetInfo?.name || presetKey,
                dataIndex: presetKey,
                key: presetKey,
                width: 120,
                align: 'center' as const,
                render: (value: number, record: ComparisonRow) => {
                    const weights = selectedPresets.map((pk) => record[pk] as number);
                    const maxWeight = Math.max(...weights);
                    const minWeight = Math.min(...weights);

                    const isMax = value === maxWeight && maxWeight !== minWeight;
                    const isMin = value === minWeight && maxWeight !== minWeight;

                    return (
                        <Tag
                            color={isMax ? 'green' : isMin ? 'red' : 'default'}
                            style={{ fontSize: 14, padding: '4px 12px' }}
                        >
                            {value}%
                        </Tag>
                    );
                },
            };
        });

        return [...baseColumns, ...presetColumns];
    };

    return (
        <Table
            dataSource={tableData}
            columns={buildColumns()}
            pagination={false}
            bordered
            size="middle"
            scroll={{ x: 800 }}
            style={{ marginTop: 24 }}
        />
    );
};
